<template>
  <v-data-table
    :headers="headers"
    :items="formattedItems"
    item-key="domain"
    hide-default-footer
    dense
  >
  </v-data-table>
</template>

<script>
import utility from "../utility/utility";
export default {
  props: {
    sriMatrixData: Object,
  },
  data() {
    return {
      headers: [
        { text: "Impacts", value: "impact" },
        {
          text: "Domestic Hot Water",
          value: "domestic_hot_water".toUpperCase(),
        },
        { text: "Cooling", value: "cooling".toUpperCase() },
        {
          text: "Monitoring and Control",
          value: "monitoring_and_control".toUpperCase(),
        },
        { text: "Lighting", value: "lighting".toUpperCase() },
        {
          text: "Electric Vehicle Charging",
          value: "electric_vehicle_charging".toUpperCase(),
        },
        { text: "Ventilation", value: "ventilation".toUpperCase() },
        { text: "Electricity", value: "electricity".toUpperCase() },
        {
          text: "Dynamic Building Envelope",
          value: "dynamic_building_envelope".toUpperCase(),
        },
        { text: "Heating", value: "heating".toUpperCase() },
      ],
      items: [],
    };
  },
  mounted() {
    if (this.sriMatrixData) this.setItems();
  },
  methods: {
    setItems: function () {
      let sriData = JSON.parse(JSON.stringify(this.sriMatrixData));
      let impacts = Object.keys(sriData).map((impact) => {
        return {
          impact: utility.convertStrToLabel(impact),
          ...sriData[impact],
        };
      });
      this.items = impacts;
    },
  },
  watch: {
    sriMatrixData: function (value) {
      console.log("in srimatrix watcher");
      if (value) {
        this.setItems();
      }
    },
  },
  computed: {
    formattedItems: function () {
      return this.items.map((item) => {
        let formattedItem = {};
        for (let key in item) {
          if (key === "impact") {
            formattedItem[key] = item[key];
          } else {
            formattedItem[key] = Math.round(item[key] * 100) + "%";
          }
        }
        return formattedItem;
      });
    },
  },
};
</script>
